<template><section><h2>Stack Bar Chart 堆叠条形图</h2>
<block-demo tip="" source="const data = [
  {
    data: &#39;05-12&#39;,
    type: &#39;图例一&#39;,
    value: 11
  },
  {
    data: &#39;05-12&#39;,
    type: &#39;图例二&#39;,
    value: 12.2
  },
  {
    data: &#39;05-13&#39;,
    type: &#39;图例一&#39;,
    value: 28
  },
  {
    data: &#39;05-13&#39;,
    type: &#39;图例二&#39;,
    value: 31
  },
  {
    data: &#39;05-14&#39;,
    type: &#39;图例一&#39;,
    value: 36
  },
  {
    data: &#39;05-14&#39;,
    type: &#39;图例二&#39;,
    value: 18
  },
  {
    data: &#39;05-15&#39;,
    type: &#39;图例一&#39;,
    value: 58
  },
  {
    data: &#39;05-15&#39;,
    type: &#39;图例二&#39;,
    value: 30.2
  },
  {
    data: &#39;05-16&#39;,
    type: &#39;图例一&#39;,
    value: 86.2
  },
  {
    data: &#39;05-16&#39;,
    type: &#39;图例二&#39;,
    value: 41.2
  },
  {
    data: &#39;05-17&#39;,
    type: &#39;图例一&#39;,
    value: 71.2
  },
  {
    data: &#39;05-17&#39;,
    type: &#39;图例二&#39;,
    value: 45.2
  },
  {
    data: &#39;05-18&#39;,
    type: &#39;图例一&#39;,
    value: 41.2
  },
  {
    data: &#39;05-18&#39;,
    type: &#39;图例二&#39;,
    value: 22.2
  },
  {
    data: &#39;05-19&#39;,
    type: &#39;图例一&#39;,
    value: 16.2
  },
  {
    data: &#39;05-19&#39;,
    type: &#39;图例二&#39;,
    value: 20.2
  }
]
const { Chart, Bar, Tooltip, Axis, Legend } = qcharts
const chart = new Chart({
  container: &#39;#app&#39;
})
chart.source(data, {
  row: &#39;type&#39;,
  value: &#39;value&#39;,
  text: &#39;data&#39;
})
const bar = new Bar({
  stack: true,
  transpose: true,
  barWidth: 20
})
const tooltip = new Tooltip()
const legend = new Legend()
const axisBottom = new Axis().style(&#39;scale&#39;, false)
const axisLeft = new Axis({
  orient: &#39;left&#39;
}).style(&#39;grid&#39;, false)
chart.append([bar, tooltip, axisBottom, axisLeft, legend])
"><pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">const</span> data = [
  {
    <span class="hljs-attr">data</span>: <span class="hljs-string">'05-12'</span>,
    <span class="hljs-attr">type</span>: <span class="hljs-string">'图例一'</span>,
    <span class="hljs-attr">value</span>: <span class="hljs-number">11</span>
  },
  {
    <span class="hljs-attr">data</span>: <span class="hljs-string">'05-12'</span>,
    <span class="hljs-attr">type</span>: <span class="hljs-string">'图例二'</span>,
    <span class="hljs-attr">value</span>: <span class="hljs-number">12.2</span>
  },
  {
    <span class="hljs-attr">data</span>: <span class="hljs-string">'05-13'</span>,
    <span class="hljs-attr">type</span>: <span class="hljs-string">'图例一'</span>,
    <span class="hljs-attr">value</span>: <span class="hljs-number">28</span>
  },
  {
    <span class="hljs-attr">data</span>: <span class="hljs-string">'05-13'</span>,
    <span class="hljs-attr">type</span>: <span class="hljs-string">'图例二'</span>,
    <span class="hljs-attr">value</span>: <span class="hljs-number">31</span>
  },
  {
    <span class="hljs-attr">data</span>: <span class="hljs-string">'05-14'</span>,
    <span class="hljs-attr">type</span>: <span class="hljs-string">'图例一'</span>,
    <span class="hljs-attr">value</span>: <span class="hljs-number">36</span>
  },
  {
    <span class="hljs-attr">data</span>: <span class="hljs-string">'05-14'</span>,
    <span class="hljs-attr">type</span>: <span class="hljs-string">'图例二'</span>,
    <span class="hljs-attr">value</span>: <span class="hljs-number">18</span>
  },
  {
    <span class="hljs-attr">data</span>: <span class="hljs-string">'05-15'</span>,
    <span class="hljs-attr">type</span>: <span class="hljs-string">'图例一'</span>,
    <span class="hljs-attr">value</span>: <span class="hljs-number">58</span>
  },
  {
    <span class="hljs-attr">data</span>: <span class="hljs-string">'05-15'</span>,
    <span class="hljs-attr">type</span>: <span class="hljs-string">'图例二'</span>,
    <span class="hljs-attr">value</span>: <span class="hljs-number">30.2</span>
  },
  {
    <span class="hljs-attr">data</span>: <span class="hljs-string">'05-16'</span>,
    <span class="hljs-attr">type</span>: <span class="hljs-string">'图例一'</span>,
    <span class="hljs-attr">value</span>: <span class="hljs-number">86.2</span>
  },
  {
    <span class="hljs-attr">data</span>: <span class="hljs-string">'05-16'</span>,
    <span class="hljs-attr">type</span>: <span class="hljs-string">'图例二'</span>,
    <span class="hljs-attr">value</span>: <span class="hljs-number">41.2</span>
  },
  {
    <span class="hljs-attr">data</span>: <span class="hljs-string">'05-17'</span>,
    <span class="hljs-attr">type</span>: <span class="hljs-string">'图例一'</span>,
    <span class="hljs-attr">value</span>: <span class="hljs-number">71.2</span>
  },
  {
    <span class="hljs-attr">data</span>: <span class="hljs-string">'05-17'</span>,
    <span class="hljs-attr">type</span>: <span class="hljs-string">'图例二'</span>,
    <span class="hljs-attr">value</span>: <span class="hljs-number">45.2</span>
  },
  {
    <span class="hljs-attr">data</span>: <span class="hljs-string">'05-18'</span>,
    <span class="hljs-attr">type</span>: <span class="hljs-string">'图例一'</span>,
    <span class="hljs-attr">value</span>: <span class="hljs-number">41.2</span>
  },
  {
    <span class="hljs-attr">data</span>: <span class="hljs-string">'05-18'</span>,
    <span class="hljs-attr">type</span>: <span class="hljs-string">'图例二'</span>,
    <span class="hljs-attr">value</span>: <span class="hljs-number">22.2</span>
  },
  {
    <span class="hljs-attr">data</span>: <span class="hljs-string">'05-19'</span>,
    <span class="hljs-attr">type</span>: <span class="hljs-string">'图例一'</span>,
    <span class="hljs-attr">value</span>: <span class="hljs-number">16.2</span>
  },
  {
    <span class="hljs-attr">data</span>: <span class="hljs-string">'05-19'</span>,
    <span class="hljs-attr">type</span>: <span class="hljs-string">'图例二'</span>,
    <span class="hljs-attr">value</span>: <span class="hljs-number">20.2</span>
  }
]
<span class="hljs-keyword">const</span> { Chart, Bar, Tooltip, Axis, Legend } = qcharts
<span class="hljs-keyword">const</span> chart = <span class="hljs-keyword">new</span> Chart({
  <span class="hljs-attr">container</span>: <span class="hljs-string">'#app'</span>
})
chart.source(data, {
  <span class="hljs-attr">row</span>: <span class="hljs-string">'type'</span>,
  <span class="hljs-attr">value</span>: <span class="hljs-string">'value'</span>,
  <span class="hljs-attr">text</span>: <span class="hljs-string">'data'</span>
})
<span class="hljs-keyword">const</span> bar = <span class="hljs-keyword">new</span> Bar({
  <span class="hljs-attr">stack</span>: <span class="hljs-literal">true</span>,
  <span class="hljs-attr">transpose</span>: <span class="hljs-literal">true</span>,
  <span class="hljs-attr">barWidth</span>: <span class="hljs-number">20</span>
})
<span class="hljs-keyword">const</span> tooltip = <span class="hljs-keyword">new</span> Tooltip()
<span class="hljs-keyword">const</span> legend = <span class="hljs-keyword">new</span> Legend()
<span class="hljs-keyword">const</span> axisBottom = <span class="hljs-keyword">new</span> Axis().style(<span class="hljs-string">'scale'</span>, <span class="hljs-literal">false</span>)
<span class="hljs-keyword">const</span> axisLeft = <span class="hljs-keyword">new</span> Axis({
  <span class="hljs-attr">orient</span>: <span class="hljs-string">'left'</span>
}).style(<span class="hljs-string">'grid'</span>, <span class="hljs-literal">false</span>)
chart.append([bar, tooltip, axisBottom, axisLeft, legend])
</code></pre>
</block-demo></section></template><script>export default {components:{}}</script>